module.exports = __webpack_public_path__ + "img/养殖贷（个人）.447152d1.png";